import { ReactComponent as ArrowBackSvg } from '../../assets/arrow-back.svg';

import { IconWrapper } from './iconWrapper';
import { IconProps } from './model';

export const ArrowBackIcon = (props: IconProps) => {
    return (
        <IconWrapper {...props}>
            <ArrowBackSvg />
        </IconWrapper>
    );
};
